(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tb-utils/verify/assets/javascripts/verify.js') >= 0) return;  svs.modules.push('/components/tb-utils/verify/assets/javascripts/verify.js');
"use strict";


let VerifyValue;
let VerifyArray;
let VerifyObject;
if (svs.isServer) {
  const _require = require('./verify-classes.es6'),
    _VerifyValue = _require.VerifyValue,
    _VerifyArray = _require.VerifyArray,
    _VerifyObject = _require.VerifyObject;
  VerifyValue = _VerifyValue;
  VerifyArray = _VerifyArray;
  VerifyObject = _VerifyObject;
} else {
  const _svs$components$tbUti = svs.components.tbUtils.verify.classes,
    _VerifyValue = _svs$components$tbUti.VerifyValue,
    _VerifyArray = _svs$components$tbUti.VerifyArray,
    _VerifyObject = _svs$components$tbUti.VerifyObject;
  VerifyValue = _VerifyValue;
  VerifyArray = _VerifyArray;
  VerifyObject = _VerifyObject;
}
const verifyValue = (value, loggger) => new VerifyValue(value, loggger);
const verifyArray = (array, loggger) => new VerifyArray(array, loggger);
const verifyObject = (object, loggger) => new VerifyObject(object, loggger);
const _exports = {
  verifyValue,
  verifyArray,
  verifyObject
};
if (svs.isServer) {
  module.exports = _exports;
} else {
  setGlobal('svs.components.tbUtils.verify', _exports);
}

 })(window);